export default "__VITE_ASSET__RnlO$YsQ__"